import {NDVSClient} from "../../client/NDVSClient";
import {
    DRIVER_PACKAGE_SUMMARY_SUCCESS,
    DRIVER_PACKAGE_SUMMARY_ERROR,
    STATION_LEVEL_ATTRIBUTES,
    DRIVER_ASSIGNED_TRACKING_ID_LIST_SUCCESS,
    DRIVER_ASSIGNED_TRACKING_ID_LIST_ERROR,
    UNASSIGNED_WEB_REJECTS, DELTA, REJECTED, DEPARTED, ASSIGNED
} from "../constants/DriverPackageSummaryConstants";


export function driverPackageSummaryNetwork( dispatcher) {
    NDVSClient.stationlevelPackageSummary({
    }).then((response) => {
        if (response.valid) {
            const stationlevelData = {}

            STATION_LEVEL_ATTRIBUTES.forEach(([columnName], index) => {
                stationlevelData[columnName] = 0;
            })
            response.data.driverAssignedPackageCount.forEach(function (driverAssignedCount){
                STATION_LEVEL_ATTRIBUTES.forEach(([columnName], index) => {
                    stationlevelData[columnName]+=driverAssignedCount[columnName];
                })
            })

            stationlevelData[DELTA] = calculateDeltaCount(stationlevelData);

            stationlevelData[UNASSIGNED_WEB_REJECTS] = response.data.unassignedRejectedCount;

            response.data.driverAssignedPackageCount.forEach(function (driverAssignedCount){
                driverAssignedCount[DELTA] = calculateDeltaCount(driverAssignedCount);
            })

            response.data.driverAssignedPackageCount.sort((driverAssignedCountObject1, driverAssignedCountObject2)=> {
                return driverAssignedCountObject2[DELTA]-driverAssignedCountObject1[DELTA]
            })

            dispatcher({
                type: DRIVER_PACKAGE_SUMMARY_SUCCESS,
                data: [response.data.driverAssignedPackageCount, stationlevelData]
            })

        } else {
            dispatcher({
                type: DRIVER_PACKAGE_SUMMARY_ERROR
            })
        }
    });
}

export function driverAssignedTrackingIdsNetwork(driverId, dispatcher) {
    NDVSClient.driverAssignedTrackingIdList({driverId
    }).then((response) => {
        if (response.valid) {

            const driverAssignedPackageIdList = {}
            driverAssignedPackageIdList[ASSIGNED] = response.data.driverAssignedPackage.assignedTrackingIdList;
            driverAssignedPackageIdList[DEPARTED] = response.data.driverAssignedPackage.departedTrackingIdList;
            driverAssignedPackageIdList[REJECTED] = response.data.driverAssignedPackage.rejectedTrackingIdList;
            driverAssignedPackageIdList[DELTA] = [];

            response.data.driverAssignedPackage.assignedTrackingIdList.forEach(function (driverAssignedPackage) {
                if (!response.data.driverAssignedPackage.departedTrackingIdList.includes(driverAssignedPackage) &&
                        !response.data.driverAssignedPackage.rejectedTrackingIdList.includes(driverAssignedPackage)) {
                    driverAssignedPackageIdList[DELTA].push(driverAssignedPackage)
                }
            })
            dispatcher({
                type: DRIVER_ASSIGNED_TRACKING_ID_LIST_SUCCESS,
                data: driverAssignedPackageIdList
            })
        } else {
            dispatcher({
                type: DRIVER_ASSIGNED_TRACKING_ID_LIST_ERROR
            })
        }
    });
}

function calculateDeltaCount(packageSummaryMap) {
    return packageSummaryMap[ASSIGNED]-packageSummaryMap[DEPARTED]-packageSummaryMap[REJECTED];
}


// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/network/DriverPackageSummaryNetwork.js